__turbopack_context__.v({
  "accordionList": "styles-module-scss-module__bABA4q__accordionList",
  "accordionListItem": "styles-module-scss-module__bABA4q__accordionListItem",
  "content": "styles-module-scss-module__bABA4q__content",
  "contentInner": "styles-module-scss-module__bABA4q__contentInner",
  "enter": "styles-module-scss-module__bABA4q__enter",
  "exit": "styles-module-scss-module__bABA4q__exit",
  "expend": "styles-module-scss-module__bABA4q__expend",
  "fade-in": "styles-module-scss-module__bABA4q__fade-in",
  "fade-out": "styles-module-scss-module__bABA4q__fade-out",
  "fade-out-80": "styles-module-scss-module__bABA4q__fade-out-80",
  "header": "styles-module-scss-module__bABA4q__header",
  "slide-in-from-bottom": "styles-module-scss-module__bABA4q__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__bABA4q__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__bABA4q__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__bABA4q__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__bABA4q__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__bABA4q__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__bABA4q__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__bABA4q__slide-out-to-top",
  "zoom-in": "styles-module-scss-module__bABA4q__zoom-in",
  "zoom-out": "styles-module-scss-module__bABA4q__zoom-out",
});
